import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'name', })
export class NamePipe implements PipeTransform {

  /* transform(): Pipe que reemplaza una cadena en un texto por otra cadena
    value: Texto que se modificará
    cut: Valor que se reemplazara
    replace: Texto de reemplazo
  */
  transform = (value: string, cut = "____", replace = " "): string => value.split(cut).join(replace);

}
